import { AxiosError } from "axios";
import { ApiRoutes } from "../../configuration/apiRoutes";
import { ClassificationRecordsTreeSearchResponse } from "../../models/ClassificationRecordsTreeSearchResponse";
import { TreeLayerRecordsResponse } from "../../models/TreeLayerRecordsResponse";
import { RestService } from "../../utils/axios";

interface IGetTreeRecordsParams {
    classifierId: string;
    parentRecordId?: number;
    treeRecordsLevel?: number;
    onDate?: Date;
    validFromDate?: Date;
    validToDate?: Date;
    classifierLocale: string;
    onSuccess: (data: TreeLayerRecordsResponse) => void;
    onFinally?: () => void;
}

export const GetTreeRecords = (params: IGetTreeRecordsParams): void => {
    RestService.Get<TreeLayerRecordsResponse>(
        ApiRoutes.Classifiers.GetRecordsTreeLayer({
            classifierId: params.classifierId,
            localeCode: params.classifierLocale,
            maxLevel: params.treeRecordsLevel,
            parentRecordId: params.parentRecordId,
            // validFromDate == validToDate => filter records that will be active during that date will be selected
            validFromDate: params.onDate ? params.onDate : params.validFromDate,
            validToDate: params.onDate ? params.onDate : params.validToDate,
        }),
        (response: TreeLayerRecordsResponse) => {
            params.onSuccess(response);
        },
        (error: AxiosError) => {
            console.log("Error: " + error.message);
        },
        () => {
            if (params.onFinally) params.onFinally();
        }
    );
};

interface ISearchTreeRecordsParams {
    classifierId: string;
    treeRecordsLevel?: number;
    searchPhrase?: string;
    onDate?: Date;
    validFromDate?: Date;
    validToDate?: Date;
    classifierLocale: string;
    onSuccess: (data: ClassificationRecordsTreeSearchResponse) => void;
    onFinally?: () => void;
}

export const SearchTreeRecords = (params: ISearchTreeRecordsParams): void => {
    RestService.Get<ClassificationRecordsTreeSearchResponse>(
        ApiRoutes.Search.GetClassificationTreeRecordResults({
            classifierId: params.classifierId,
            localeCode: params.classifierLocale,
            maxLevel: params.treeRecordsLevel,
            searchPhrase: params.searchPhrase,
            // validFromDate == validToDate => filter records that will be active during that date will be selected
            validFromDate: params.onDate ? params.onDate : params.validFromDate,
            validToDate: params.onDate ? params.onDate : params.validToDate,
        }),
        (response: ClassificationRecordsTreeSearchResponse) => {
            params.onSuccess(response);
        },
        (error: AxiosError) => {
            console.log("Error: " + error.message);
        },
        () => {
            if (params.onFinally) params.onFinally();
        }
    );
};
